// Чипсы активных фильтров и снятие фильтра по ключу.
//
// Логика жила внутри CarsCommandBar, но она нужна и там, где командной панели нет:
// на /search_free у фильтров своя узкая шапка (ни списка/доски, ни экспорта, ни
// скоупа — только кнопка «Фильтры» и чипсы). Поэтому вынесена в чистые функции:
// перевод приходит параметром, DOM и Vue здесь не участвуют.
import { SLUG_MAPS } from "@/components/dashboard/cars/carDictionaries";

// Порядок ключей = порядок чипсов на экране.
export const CHIP_KEYS = ["state", "car_type", "transmission", "fuel", "tag_ids", "in_rent", "active", "price_group_id"];

function typePrefix(rentalObject) {
  if (rentalObject === "bicycles") return "bike_types.";
  if (rentalObject === "motorcycles") return "motorcycle_types.";
  return "car_types.";
}

function stateText(t, state) {
  const keys = {
    1: "states.normal", 2: "states.in_service", 3: "states.critical",
    4: "states.long_rent", 5: "states.no_rent", 6: "states.service_needed",
  };
  return keys[state] ? t(keys[state]) : String(state);
}

// filters — текущее состояние фильтров; t — функция перевода ($t);
// include — какие ключи вообще применимы на этой странице (на /search_free
// «в аренде» и «активные» не применимы: эндпоинт их не принимает, чип обещал бы
// фильтр, которого нет).
// priceGroupText — подпись выбранной ценовой группы (FT-217): саму подпись знает
// только доска (границы min/max из ответа), поэтому приходит параметром.
export function activeFilterChips(filters, { t, rentalObject = "cars", include = CHIP_KEYS, priceGroupText = null } = {}) {
  const f = filters || {};
  const on = (key) => include.indexOf(key) !== -1;
  const chips = [];

  if (on("state") && f.state && f.state.length) {
    chips.push({ key: "state", label: t("custom.state"), text: f.state.map((s) => stateText(t, s)).join(", ") });
  }
  if (on("car_type") && f.car_type) {
    const slug = SLUG_MAPS.toSlug.car_type[f.car_type];
    chips.push({
      key: "car_type",
      label: t("cars_board.type_label"),
      text: slug ? t(typePrefix(rentalObject) + slug) : f.car_type,
    });
  }
  if (on("transmission") && f.transmission) {
    const slug = SLUG_MAPS.toSlug.transmission[f.transmission];
    chips.push({ key: "transmission", label: t("cars.gear_big"), text: slug ? t("transmissions." + slug) : f.transmission });
  }
  if (on("fuel") && f.fuel) {
    const slug = SLUG_MAPS.toSlug.fuel[f.fuel];
    chips.push({ key: "fuel", label: t("cars.fuel"), text: slug ? t("fuels." + slug) : f.fuel });
  }
  if (on("tag_ids") && f.tag_ids && f.tag_ids.length) {
    chips.push({ key: "tag_ids", label: t("custom.tags"), text: String(f.tag_ids.length) });
  }
  // Фильтры, живущие только у поиска свободных: в CHIP_KEYS по умолчанию их нет,
  // поэтому страницы парка их не увидят.
  if (on("min_seats") && f.min_seats) {
    chips.push({ key: "min_seats", label: t("cars.number_seats_from"), text: String(f.min_seats) });
  }
  if (on("is_air") && f.is_air === true) {
    chips.push({ key: "is_air", label: t("cars.is_air"), text: t("custom.yes") });
  }
  if (on("no_deposit") && f.no_deposit === true) {
    chips.push({ key: "no_deposit", label: t("cars.no_deposit"), text: t("custom.yes") });
  }
  if (on("in_rent") && f.in_rent === true) {
    chips.push({ key: "in_rent", label: t("cars_board.in_rent_now"), text: t("custom.yes") });
  }
  if (on("active") && f.active === true) chips.push({ key: "active", label: t("custom.active"), text: t("custom.yes") });
  else if (on("active") && f.active === false) chips.push({ key: "active", label: t("custom.active"), text: t("custom.no") });
  // FT-217 REQ-06: фильтр доски «Ближайшие дни» по ценовой группе — чип со сбросом.
  // Фильтр живёт только в этой группировке, вне её чипа нет.
  if (on("price_group_id") && f.group_by === "upcoming" && f.price_group_id != null) {
    const text = priceGroupText || (f.price_group_id === "none" ? t("price_groups.no_price") : `#${f.price_group_id}`);
    chips.push({ key: "price_group_id", label: t("price_groups.group_label"), text });
  }

  return chips;
}

// Снятие одного фильтра. Пустое значение у каждого ключа своё: список — [],
// тумблер — null, одиночный выбор — null.
export function withFilterCleared(filters, key) {
  const next = { ...(filters || {}) };
  if (key === "state") next.state = [];
  else if (key === "tag_ids") next.tag_ids = [];
  else if (key === "in_rent") next.in_rent = null;
  else if (key === "active") next.active = null;
  // тумблеры поиска свободных: пустое значение у них false, а не null —
  // null в v-checkbox читается как «не определено» и оставляет галку в чужом состоянии
  else if (key === "is_air" || key === "no_deposit") next[key] = false;
  else next[key] = null;
  return next;
}
